import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'cdp-upload-button',
  templateUrl: './upload-button.component.html',
  styleUrls: ['./upload-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadButtonComponent implements OnInit {
  @Output() fileNameChangeEvent = new EventEmitter<string>();
  @Output() fileChangeEvent = new EventEmitter<File>();
  @Input() className = 'cds-btn cds-light-blue-button';
  @Input() buttonName = 'SSL_CERTIFICATES_SETTINGS.SSL_ITEM.BUTTONS.UPLOAD';
  @Input() fileType = '';
  constructor() {}

  onFileSelected(event) {
    const file = event.target.files[0];

    if (file) {
      this.fileNameChangeEvent.emit(file.name);
      this.fileChangeEvent.emit(file);
    }
  }
  ngOnInit() {}
}
